import { COMMON_CONSTANTS, getTranslatedText } from '@nile/components/src';

const TABS = (flags, intl) => {
  const tabs = [
    {
      name: 'intelligentAlerting',
      label: getTranslatedText(
        intl,
        'admin.policyManagement.intelligentAlerting.tabs'
      ),
      icon: 'Insights',
      isSuperIcon: true
    },
    {
      name: 'alertManagement',
      label: getTranslatedText(
        intl,
        'admin.policyManagement.alertManagement.tabs'
      ),
      icon: 'AlertIcon',
      isSuperIcon: true
    },
    {
      name: 'patchManagement',
      label: getTranslatedText(
        intl,
        'admin.policyManagement.patchManagement.tabs'
      ),
      icon: 'PatchLight',
      isSuperIcon: true
    },
    {
      name: 'scheduleActions',
      label: getTranslatedText(
        intl,
        'admin.policyManagement.scheduleActions.tabs'
      ),
      icon: 'Script',
      isSuperIcon: true
    },
    {
      name: 'antivirus',
      label: getTranslatedText(intl, 'admin.policyManagement.antivirus.tabs'),
      icon: 'AntivirusPolicy',
      isSuperIcon: true
    },
    {
      name: 'softwareManagement',
      label: getTranslatedText(
        intl,
        'admin.policyManagement.softwareManagement.tabs'
      ),
      icon: 'SoftwareBundle',
      flag: 'windowsPatchManagement',
      isSuperIcon: true
    },
    {
      name: 'assetGroup',
      label: getTranslatedText(intl, 'admin.policyManagement.assetGroup.tabs'),
      icon: 'AssetGroup',
      isSuperIcon: true,
      permission: 'assetGroup.view'
    },
    {
      name: 'dataBackup',
      label: getTranslatedText(intl, 'admin.policyManagement.dataBackup.tabs'),
      icon: 'Backup',
      isSuperIcon: true
    },
    {
      name: 'remote',
      label: getTranslatedText(intl, 'asset.remote.header'),
      icon: 'RemoteDesktop',
      isSuperIcon: true,
      permission: 'integrations.view'
    },
    {
      name: 'systemTray',
      label: getTranslatedText(intl, 'app.article.systemTray'),
      icon: 'SystemTrayIcon',
      isSuperIcon: true
    },
    {
      name: 'assetOnboarding',
      label: getTranslatedText(intl, 'msp.policyMng.asset.onboarding.title'),
      icon: 'AssetGroup',
      isSuperIcon: true
    }
  ];
  if (flags?.maintenanceWindow) {
    tabs.push({
      name: 'mainatenance',
      label: getTranslatedText(intl, 'admin.maintenance.header'),
      icon: 'Maintenance',
      isSuperIcon: true
    });
  }
  return tabs;
};

export default TABS;
